













import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
@Component
export default class ColorSelect extends Vue {
    @Prop({ default: () => [] }) options: CommonTypes.mapObject[];
    @Prop({ default: false }) multiple: boolean;
    @Prop({ default: true }) inline: boolean;
    @Prop({ default: '不可选择' }) disableHint: string;
    @Prop({ default: 'label' }) labelText: string;

    colorOptions: CommonTypes.mapObject[] = [];
    selectedColors: string[] = [];

    @Watch('options', { immediate: true, deep: true })
    onOptionsChanged(options) {
        if (options) {
            this.colorOptions = cloneDeep(options);
            this.selectedColors = this.colorOptions.filter(item => item.selected).map(item => item.color);
        }
    }
    onItemClicked(item: CommonTypes.mapObject) {
        if (item.disabled) {
            return;
        }
        if (!this.multiple) {
            this.colorOptions.map(option => {
                option.selected = option.color === item.color ? !option.selected : false;
            });
        } else {
            item.selected = !item.selected;
        }
        this.selectedColors = this.colorOptions.filter(item => item.selected).map(item => item.color);
        this.$emit('change', this.colorOptions);
    }
}
